export const TelemetryType = {
    log: 'log',
    configuration: 'configuration',
    usage: 'usage',
};
//# sourceMappingURL=rawTelemetryEvent.types.js.map


// WEBPACK FOOTER //
// ./~/@datadog/browser-rum/~/@datadog/browser-core/esm/domain/telemetry/rawTelemetryEvent.types.js